import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "../../../styles";

export const matchStatsContainer = style({
  display: "flex",
  justifyContent: "center",
});

export const statsList = style({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  width: "100%",
  "@media": {
    [`screen and (min-width:${breakpoints[1]})`]: {
      maxWidth: "50%",
    },
  },
});

export const statWrapper = style({
  display: "flex",
  flexDirection: "column",
  border: `1px solid ${vars.colors.surfaceVariant}`,
  borderRadius: vars.radii.s,
  color: vars.colors.onSurface,
});

export const statHeader = style({
  borderStartStartRadius: vars.radii.xs,
  borderStartEndRadius: vars.radii.xs,
  backgroundColor: vars.colors.surfaceVariant,
  padding: `${vars.space["2xs"]} 0`,
  textAlign: "center",
  color: vars.colors.onSurface,
  fontSize: vars.fontSizes.heading.s,
});

export const statContent = style({
  display: "flex",
  justifyContent: "center",
  padding: vars.space.xs,
});

export const itemStyle = style({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: vars.space.xs,
  listStyleType: "none",
  textAlign: "start",
  selectors: {
    "&:first-child": {
      marginInlineEnd: vars.space.m,
      borderInlineEnd: vars.borders.outlineVariant,
      paddingInlineEnd: vars.space.m,
      textAlign: "end",
    },
  },
});
